import React from 'react';
import { bool, func, node, object, oneOf, string } from 'prop-types';
import Icon from '@material-ui/core/Icon';

// The one notice style: slim, light blue (light red for errors), small icon, optional close
const tones = {
  info: { light: ['#E3EDFA', 'rgba(0, 0, 0, 0.87)'], dark: ['#22344F', '#FFFFFF'] },
  error: { light: ['#FDECEA', '#8A1C14'], dark: ['#4A2323', '#FFD7D2'] },
  tip: { light: ['transparent', '#5F6B7A'], dark: ['transparent', '#B8C2D0'] }
};

const Notice = ({ id, tone, icon, onClose, nightModeEnabled, children, style }) => {
  const [backgroundColor, color] = tones[tone][nightModeEnabled ? 'dark' : 'light'];
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: tone === 'tip' ? '2px 0' : '8px 12px',
        borderRadius: 8,
        backgroundColor,
        color,
        fontSize: tone === 'tip' ? 13 : 14,
        lineHeight: 1.45,
        ...style
      }}
    >
      {icon && <Icon style={{ fontSize: tone === 'tip' ? 18 : 20, flexShrink: 0 }}>{icon}</Icon>}
      <div id={id} style={{ flex: '1 1 auto', minWidth: 0 }}>
        {children}
      </div>
      {onClose && (
        <Icon
          role="button"
          aria-label="Close"
          title="Close"
          onClick={onClose}
          style={{ fontSize: 18, cursor: 'pointer', flexShrink: 0 }}
        >
          close
        </Icon>
      )}
    </div>
  );
};

Notice.propTypes = {
  id: string,
  tone: oneOf(['info', 'error', 'tip']),
  icon: string,
  onClose: func,
  nightModeEnabled: bool,
  children: node,
  style: object
};

Notice.defaultProps = {
  tone: 'info'
};

export default Notice;
